/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatePalNpiRequest
 */
export interface ValidatePalNpiRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiRequest
     */
    npi: string;
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiRequest
     */
    field_name: ValidatePalNpiRequestFieldNameEnum;
}


/**
 * @export
 */
export const ValidatePalNpiRequestFieldNameEnum = {
    OrderingFacilityNpi: 'ordering_facility_npi',
    OrderingPhysicianNpi: 'ordering_physician_npi',
    AttendingAcutePhysicianNpi: 'attending_acute_physician_npi',
    ServicingPacFacilityNpi: 'servicing_pac_facility_npi'
} as const;
export type ValidatePalNpiRequestFieldNameEnum = typeof ValidatePalNpiRequestFieldNameEnum[keyof typeof ValidatePalNpiRequestFieldNameEnum];


/**
 * Check if a given object implements the ValidatePalNpiRequest interface.
 */
export function instanceOfValidatePalNpiRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "npi" in value;
    isInstance = isInstance && "field_name" in value;

    return isInstance;
}

export function ValidatePalNpiRequestFromJSON(json: any): ValidatePalNpiRequest {
    return ValidatePalNpiRequestFromJSONTyped(json, false);
}

export function ValidatePalNpiRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'npi': json['npi'],
        'field_name': json['field_name'],
    };
}

export function ValidatePalNpiRequestToJSON(value?: ValidatePalNpiRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'npi': value.npi,
        'field_name': value.field_name,
    };
}

